
import { Book, FileText, Video } from "lucide-react";
import { Link } from "react-router-dom";
import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
} from "@/components/ui/card";
import { Button } from "@/components/ui/button";

// Resource type definitions
interface Resource {
  id: string;
  title: string;
  description: string;
  icon: "book" | "file" | "video";
  link: string;
}

// Mock resources data
const RESOURCES: Resource[] = [
  {
    id: "1",
    title: "Understanding Cayman's Government",
    description:
      "Learn about the structure and function of the Cayman Islands government, including the roles of elected representatives.",
    icon: "book",
    link: "",
  },
  {
    id: "2",
    title: "Effective Civic Engagement Guide",
    description:
      "Step-by-step guide to making your voice heard through various channels in the Cayman Islands.",
    icon: "file",
    link: "",
  },
  {
    id: "3",
    title: "How to Analyze Poll Data",
    description:
      "Video tutorial explaining how to interpret NationCard™ polling data and understand statistical significance.",
    icon: "video",
    link: "",
  },
  {
    id: "4",
    title: "Rights & Responsibilities",
    description:
      "Overview of citizen rights and responsibilities in the Cayman Islands' democratic system.",
    icon: "book",
    link: "",
  },
];

const ResourcesGrid = () => {
  // Helper function to render the appropriate icon
  const renderIcon = (iconType: string) => {
    switch (iconType) {
      case "book":
        return <Book className="h-6 w-6" />;
      case "file":
        return <FileText className="h-6 w-6" />;
      case "video":
        return <Video className="h-6 w-6" />;
      default:
        return <Book className="h-6 w-6" />;
    }
  };

  return (
    <section className="py-16 px-4 bg-white dark:bg-gray-900">
      <div className="container mx-auto max-w-6xl">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold mb-2">
            Civic Education Resources
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto">
            Empower yourself with knowledge about Cayman's democratic process
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
          {RESOURCES.map((resource) => (
            <Card key={resource.id} className="h-full flex flex-col">
              <CardHeader className="pb-2">
                <div className="w-10 h-10 bg-nation-purple/10 text-nation-purple rounded-full flex items-center justify-center mb-3">
                  {renderIcon(resource.icon)}
                </div>
                <h3 className="font-semibold">{resource.title}</h3>
              </CardHeader>
              <CardContent className="pb-2 flex-grow">
                <p className="text-sm text-muted-foreground">
                  {resource.description}
                </p>
              </CardContent>
              <CardFooter>
                <Button variant="outline" size="sm" className="w-full" asChild>
                  <Link to={resource.link}>Coming Soon</Link>
                </Button>
              </CardFooter>
            </Card>
          ))}
        </div>

        <div className="text-center">
          <Button asChild>
            <Link to="/civic-education">View All Resources</Link>
          </Button>
        </div>
      </div>
    </section>
  );
};

export default ResourcesGrid;
